export const OWNER_CPD = 1;
export const OWNER_NCI = 2;
